import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import Archive from '@crehana/compass.icons.outline/Archive';
import Calendar5 from '@crehana/compass.icons.outline/Calendar';
import ColorPicker from '@crehana/compass.icons.outline/ColorPicker';
import Diploma from '@crehana/compass.icons.outline/Diploma';
import Globe2 from '@crehana/compass.icons.outline/Globe2';
import Home from '@crehana/compass.icons.outline/Home';
import Percent from '@crehana/compass.icons.outline/Percent';
import Playsquare from '@crehana/compass.icons.outline/Playsquare';
import CompassRanking from '@crehana/compass.icons.outline/Ranking';
import SkillXp from '@crehana/compass.icons.outline/SkillXp';
import useIsPlayRoomActivated from '@crehana/compass.playroom/shared/hooks/useIsPlayRoomActivated';
import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import { isProduction } from "../../../constants";
import { useKnowledgeHubAvailabilityStatus } from "../../../hooks/use-knowledge-hub-status";
import { useFlagOrganization } from "../../../hooks/useFlagOrganization";
import HelperTooltip from "../../SidebarMenu/components/HelperTooltip";
import useLearning from "../useLearning";
import useCollaboratorTranslations from "./useCollaboratorTranslations";
import { jsx as _jsx } from "react/jsx-runtime";
var cleanEmptyPaths = function cleanEmptyPaths(paths) {
  return paths.filter(Boolean);
};
var useB2BRoutes = function useB2BRoutes(_ref) {
  var organizationSlug = _ref.organizationSlug,
    productPlatform = _ref.productPlatform,
    email = _ref.email,
    routesExtraData = _ref.routesExtraData,
    organizationId = _ref.organizationId;
  var _useCollaboratorTrans = useCollaboratorTranslations(),
    t = _useCollaboratorTrans.t;
  var baseURL = base(organizationSlug, productPlatform);
  var _useLearning = useLearning({
      email: email
    }),
    myRole = _useLearning.myRole,
    isB2BOnlyPanel = _useLearning.isB2BOnlyPanel;
  var _useIsPlayRoomActivat = useIsPlayRoomActivated(organizationSlug),
    isPlayroomEnabled = _useIsPlayRoomActivat.isActivated;
  var _useFlagOrganization = useFlagOrganization({
      flag: 'activate-oldest-skillxp',
      organizationSlug: organizationSlug
    }),
    isOldSkillXPActive = _useFlagOrganization.isActive,
    loadingOldSkillXP = _useFlagOrganization.isLoading;
  var _useKnowledgeHubAvail = useKnowledgeHubAvailabilityStatus({
      organizationId: organizationId.toString()
    }),
    isKnowledgeHubEnabled = _useKnowledgeHubAvail.hasKnowledgeHubAvailable,
    loadingKnowledgeHub = _useKnowledgeHubAvail.loading;
  var _useFlagOrganization2 = useFlagOrganization({
      flag: 'NEW_HIGHER_EDUCATION_HOME_USER',
      organizationSlug: organizationSlug
    }),
    hideMarketplaceUIFF = _useFlagOrganization2.isActive,
    loadingMarketplace = _useFlagOrganization2.isLoading;
  var isMarketplaceUser = myRole === 'high-education-member';
  var hideMarketplaceNavbarMenu = isMarketplaceUser && hideMarketplaceUIFF;
  var shouldRenderSkillXPTab = isOldSkillXPActive;
  var shouldRenderPlayroom = isPlayroomEnabled;
  var shouldRenderKnowledgeHub = isKnowledgeHubEnabled;
  var shouldRenderResources = !hideMarketplaceNavbarMenu && !shouldRenderKnowledgeHub && !isB2BOnlyPanel;
  var LEARN_DASHBOARD_START = {
    code: 'LEARN_HOME_START',
    label: t('MODULE_HOME'),
    url: baseURL + '/',
    icon: Home
  };
  var LEARN_DASHBOARD_KNOWLEDGE_HUB = {
    icon: Globe2,
    code: 'LEARN_KNOWLEDGE_HUB',
    url: baseURL + '/content/',
    label: t('LEARNING_LINK_KNOWLEDGE_HUB')
  };
  var LEARN_DASHBOARD_MY_COURSES = {
    code: 'LEARN_ENROLLED_COURSES',
    url: baseURL + '/my-courses/enrolled/',
    label: t('LEARNING_LINK_ENROLLED_COURSES')
  };
  var LEARN_DASHBOARD_TRACKS = {
    code: 'LEARN_TRACKS',
    url: baseURL + '/my-courses/tracks/',
    label: t('LEARNING_LINK_PATHS')
  };
  var LEARN_DASHBOARD_LIVE_SESSIONS = {
    code: 'LEARN_LIVE_SESSIONS',
    url: baseURL + '/my-courses/live-sessions/',
    label: t('LEARNING_LINK_LIVE_SESSIONS'),
    isLocked: true
  };
  var LEARN_DASHBOARD_NOTES = {
    code: 'LEARN_NOTES',
    url: baseURL + '/my-courses/notes/',
    label: t('LEARNING_LINK_NOTES')
  };
  var LEARN_DASHBOARD_STUDY_PLAN = {
    code: 'LEARN_STUDY_PLAN',
    icon: Calendar5,
    label: t('LEARNING_LINK_STUDY_PLAN'),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('LEARNING_LINK_STUDY_PLAN'),
      description: t('LEARNING_LINK_TOOLTIP_STUDY_PLAN')
    }),
    url: baseURL + '/studyplan/'
  };
  var LEARN_DASHBOARD_BLOG = {
    code: 'LEARN_RESOURCES_BLOG',
    url: "".concat(CREHANA_BASE_URL_PRD, "/blog/"),
    label: t('LEARNING_LINK_BLOG')
  };
  var LEARN_DASHBOARD_LIVES = {
    code: 'LEARN_RESOURCES_LIVES',
    url: "".concat(CREHANA_BASE_URL_PRD, "/live/"),
    label: t('LEARNING_LINK_LIVES')
  };
  var LEARN_DASHBOARD_TOOLS = {
    code: 'LEARN_RESOURCES_TOOLS',
    url: "".concat(CREHANA_BASE_URL_PRD, "/recursos/herramientas/"),
    label: t('LEARNING_LINK_TOOLS')
  };
  var LEARN_DASHBOARD_SKILL_XP = {
    code: 'LEARN_SKILLXP',
    icon: Percent,
    label: t('LEARNING_LINK_SKILL_XP'),
    subtitle: t('LEARNING_LINK_EVALUATIONS_AND_GOALS'),
    url: baseURL + '/skill-xp/'
  };
  var LEARN_DASHBOARD_PROJECTS = {
    code: 'LEARN_PROJECTS',
    label: t('LEARNING_LINK_PROJECTS'),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('LEARNING_LINK_PROJECTS'),
      description: t('LEARNING_LINK_TOOLTIP_PROJECTS_DESCRIPTION')
    }),
    icon: Archive,
    url: baseURL + '/projects/'
  };
  var LEARN_DASHBOARD_CERTIFICATES = {
    code: 'LEARN_CERTIFICATES',
    icon: Diploma,
    tourSelector: 'diplomas-tab',
    label: t('LEARNING_LINK_DIPLOMA'),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('LEARNING_LINK_DIPLOMA'),
      description: t('LEARNING_LINK_TOOLTIP_DIPLOMA_DESCRIPTION')
    }),
    url: baseURL + '/certificates/',
    exact: true
  };
  var LEARN_DASHBOARD_SKILL_XP_EVOLUTION_PENDING = {
    code: 'LEARN_SKILL_XP_EVOLUTION_PENDING',
    icon: SkillXp,
    label: t('LEARNING_LINK_PENDING_TESTS'),
    url: baseURL + '/skill-xp-evolution/pending/'
  };
  var LEARN_DASHBOARD_SKILL_XP_EVOLUTION_SOLVED = {
    code: 'LEARN_SKILL_XP_EVOLUTION_SOLVED',
    icon: SkillXp,
    label: t('LEARNING_LINK_DONE_TESTS'),
    url: baseURL + '/skill-xp-evolution/solved/'
  };
  var LEARN_DASHBOARD_PLAYROOM_ACHIEVEMENTS = {
    code: 'LEARN_DASHBOARD_PLAYROOM_ACHIEVEMENTS',
    icon: Percent,
    label: t('LEARNING_LINK_ACCHIEVEMENTS'),
    url: baseURL + '/playroom/achievements/'
  };
  var LEARN_DASHBOARD_PLAYROOM_REWARDS = {
    code: 'LEARN_DASHBOARD_PLAYROOM_REWARDS',
    icon: Percent,
    label: t('LEARNING_LINK_REWARDS'),
    url: baseURL + '/playroom/rewards/'
  };
  var LEARN_DASHBOARD_SKILL_XP_EVOLUTION = !hideMarketplaceNavbarMenu ? {
    code: 'LEARN_SKILL_XP_EVOLUTION',
    icon: SkillXp,
    label: t('LEARNING_LINK_SKILL_XP_EVOLUTION'),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('LEARNING_LINK_SKILL_XP_EVOLUTION'),
      description: t('LEARNING_LINK_TOOLTIP_SKILL_XP_EVOLUTION_DESCRIPTION')
    }),
    nested: [LEARN_DASHBOARD_SKILL_XP_EVOLUTION_PENDING, LEARN_DASHBOARD_SKILL_XP_EVOLUTION_SOLVED]
  } : undefined;
  var LEARN_DASHBOARD_PLAYROOM = {
    code: 'LEARN_DASHBOARD_PLAYROOM',
    icon: CompassRanking,
    label: t('LEARNING_LINK_GAMIFICATION'),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('LEARNING_LINK_GAMIFICATION'),
      description: t('LEARNING_LINK_TOOLTIP_GAMIFICATION_DESCRIPTION')
    }),
    nested: [LEARN_DASHBOARD_PLAYROOM_ACHIEVEMENTS, LEARN_DASHBOARD_PLAYROOM_REWARDS]
  };
  var nestedIsWithLiveSessions = [LEARN_DASHBOARD_MY_COURSES, LEARN_DASHBOARD_TRACKS, LEARN_DASHBOARD_LIVE_SESSIONS, LEARN_DASHBOARD_NOTES];
  var getSideMenuRoutes = function getSideMenuRoutes() {
    return cleanEmptyPaths([LEARN_DASHBOARD_START, shouldRenderKnowledgeHub ? LEARN_DASHBOARD_KNOWLEDGE_HUB : undefined, {
      code: 'LEARN_ENROLLMENTS',
      icon: Playsquare,
      label: t('LEARNING_LINK_MY_COURSES'),
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('LEARNING_LINK_MY_COURSES'),
        description: t('LEARNING_LINK_TOOLTIP_MY_COURSES_DESCRIPTION')
      }),
      subtitle: t('LEARNING_LINK_LEARND_AND_PROGRESS'),
      nested: hideMarketplaceNavbarMenu ? [LEARN_DASHBOARD_TRACKS, LEARN_DASHBOARD_NOTES] : nestedIsWithLiveSessions
    },
    // @ts-expect-error error inference
    shouldRenderPlayroom ? LEARN_DASHBOARD_PLAYROOM : undefined, LEARN_DASHBOARD_STUDY_PLAN, shouldRenderResources ? {
      code: 'LEARN_RESOURCES',
      icon: ColorPicker,
      label: t('LEARNING_LINK_RESOURCES'),
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('LEARNING_LINK_RESOURCES'),
        description: t('LEARNING_LINK_TOOLTIP_RESOURCES_DESCRIPTION')
      }),
      nested: [LEARN_DASHBOARD_BLOG, LEARN_DASHBOARD_LIVES, LEARN_DASHBOARD_TOOLS]
    } : undefined, shouldRenderSkillXPTab ? LEARN_DASHBOARD_SKILL_XP : undefined,
    // @ts-expect-error error inference
    LEARN_DASHBOARD_SKILL_XP_EVOLUTION, _objectSpread(_objectSpread({}, LEARN_DASHBOARD_PROJECTS), {}, {
      subtitle: !shouldRenderSkillXPTab ? t('LEARNING_LINK_EVALUATIONS_AND_GOALS') : undefined
    }), LEARN_DASHBOARD_CERTIFICATES]);
  };
  var isLoading = loadingKnowledgeHub || loadingMarketplace || loadingOldSkillXP;
  var b2bRoutes = isLoading ? [] : getSideMenuRoutes();
  if (routesExtraData) {
    b2bRoutes = b2bRoutes.map(function (route) {
      if (route.nested) {
        return _objectSpread(_objectSpread(_objectSpread({}, route), routesExtraData[route.code]), {}, {
          nested: _toConsumableArray(route.nested.map(function (nestedRoute) {
            return _objectSpread(_objectSpread({}, nestedRoute), routesExtraData[nestedRoute.code]);
          }))
        });
      }
      return _objectSpread(_objectSpread({}, route), routesExtraData[route.code]);
    });
  }
  return {
    b2bRoutes: b2bRoutes,
    isKnowledgeHubEnabled: isKnowledgeHubEnabled,
    isPlayroomEnabled: isPlayroomEnabled,
    isLoading: isLoading
  };
};
export default useB2BRoutes;
var base = function base(_orgSlug, productPlatform) {
  if (productPlatform === 'talent') {
    var BASE_URL = isProduction ? 'https://crehana.com' : 'https://qa.creha.co';
    return BASE_URL + '/org/' + _orgSlug + '/learn';
  }
  return '/org/' + _orgSlug + '/learn';
};